import Vue from './libs/vue.esm.js'
import VueI18n from './libs/vue-i18n.esm.js'

// console.warn({ Vue, VueI18n })

Vue.use(VueI18n)

const fallbackLocale = ['en']


let locale;
if (globalThis?.vpage2_variables) {
    // contexte vpage2 
    locale = globalThis?.vpage2_variables?.languages?.locale?.value || navigator.language

}
else {
    // context vconsole
    // account language
    const account_language = globalThis?.variables?.translate25_language || undefined

    locale =
        account_language ??
        localStorage?.language ??
        navigator.language

    console.info('[i18n] Locale determined from:', account_language ? 'account language' : (localStorage?.language ? 'localStorage' : 'navigator'), locale)
}

// if (process.env.NODE_ENV !== 'production') {
//     locale =
//         localStorage?.language ??
//         navigator.language
// }

globalThis.translate25_locale = locale


const i18n = new VueI18n({
    locale, // localStorage?.language ?? navigator.language,
    fallbackLocale,
    formatFallbackMessages: true,
    silentFallbackWarn: true, // overrided in dev
    silentTranslationWarn: true, // overrided in dev
    messages: {}
})


// **********************************
// *** temporary code to ***

Vue.prototype.$vt = function (key) {
    return key
}

Vue.prototype.$vtc = function (key, count) {
    if (typeof key === 'string') {
        return key.split('|')[0]
    }
    else return key
}

Vue.prototype.$vn = function (key) {
    return key
}
// *** remove this code when the translation is done



export default Vue
export { VueI18n, i18n }
